
import React, { useState, useEffect } from "react";
import { Configurations } from "../../../Utils/Configurations";
import './HighLightsV2.scss';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import HighLightItemList from "../../../Components/HighLight-Item-List/HighLight-Item-List";
// import { Nav, NavItem, TabContent, TabPane, NavLink } from "reactstrap";

const HighLightsV2List = ({ history }) => {
    const [hub, setHub] = useState([])
    const [bsMais, setBsMais] = useState([])
    const [loading, setLoading] = useState(true)
    // const [abaSelecionada, setAbaSelecionada] = useState('1');

    const chamadaBanners = () => {
        const config = new Configurations();
        axios.get(config.apiBasePath + `/v2/destaques`)
            .then(response => {
                setHub(response.data.destaquesHub)
                setBsMais(response.data.destaquesBM)
            })
            .catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() => {
                setLoading(false)
            });
    }

    // const selecionarAba = (aba) => {
    //     setAbaSelecionada(aba);
    // }

    const alteraPosicao = (item, direcao) => {

        const body = {
            idDestaque: item._id,
            localizacao: item.localizacao,
            direcao: direcao
        }

        const config = new Configurations();
        axios.post(config.apiBasePath + `/v2/destaques/ordem`, body)
            .then((response) => {
                if (item.localizacao === 'hub') {
                    setHub(response.data.data)
                } else {
                    setBsMais(response.data.data)
                }
            })
            .catch(err => {
                console.log("ERROR: ", err)
            })
    }

    const excluirDestaque = (item) => {
        const config = new Configurations();
        setLoading(true);
        axios.delete(config.apiBasePath + `/v2/destaques/${item._id}?localizacao=${item.localizacao}`)
            .then((response) => {
                console.log("RESPONSE DATAAAAAAAAAA ", response.data)
            })
            .catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() => {
                chamadaBanners();
            });
    }

    useEffect(() => {
        chamadaBanners()
    }, [])

                            console.log("🚀 ~ HighLightsV2List ~ hub:", hub)
    return (
        <div className="cile-remessas">
            <div className="row">
                <div className="col-12 py-2">
                    <div className="row no-gutters align-items-center">
                        <div className="col-12 col-lg-4 text-center text-lg-left">
                            <h2 className="title-1 d-none d-lg-block">Destaques</h2>
                        </div>
                        <div className="col-6 col-lg-4 text-center text-lg-center">
                            <button className="btn btn-outline-primary" onClick={() => history.push('/v2/destaques/detalhes/novo')} type="button">
                                Novo
                            </button>
                        </div>
                        <div className="col-6 col-lg-4 text-center text-lg-right">
                            <div className="row no-gutters">
                                <div className="col py-2 py-lg-0">
                                    <button onClick={() => window.history.go(-1)} className="btn btn-outline-secondary">voltar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card">
                <div className="no-gutters align-items-center py-lg-4 px-lg-3">


                    {loading ?
                        <div className="d-flex justify-content-center w-100">
                            <div className="spinner-border text-primary" role="status" />
                        </div>
                        :
                        <>

                            {hub && hub.map((item, index) => {
                                return (
                                    <HighLightItemList
                                        conteudo={item}
                                        setLoading={setLoading}
                                        chamadaBanners={chamadaBanners}
                                        index={index}
                                        alteraPosicao={alteraPosicao}
                                        excluirDestaque={excluirDestaque}
                                        total={hub.length}
                                    />
                                )
                            })}
                            {/* <Nav tabs>
                                <NavItem className="aba-bsmais text-center">
                                    <NavLink className={abaSelecionada === '1' ? 'classe-ativada-bsmais' : 'classe-inativa'} onClick={() => { selecionarAba('1'); }}>
                                        Hub
                                    </NavLink>
                                </NavItem>
                                <NavItem className="aba-hub text-center">
                                    <NavLink className={abaSelecionada === '2' ? 'classe-ativada-hub' : 'classe-inativa'} onClick={() => { selecionarAba('2'); }}>
                                        BS+
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab={abaSelecionada}>
                                <TabPane tabId="1">
                                    {hub && hub.map((item, index) => {
                                        return (
                                            <HighLightItemList
                                                conteudo={item}
                                                setLoading={setLoading}
                                                chamadaBanners={chamadaBanners}
                                                index={index}
                                                alteraPosicao={alteraPosicao}
                                                excluirDestaque={excluirDestaque}
                                            />
                                        )
                                    })}
                                </TabPane>
                                <TabPane tabId="2">
                                    {bsMais && bsMais.map((item, index) => {
                                        return (
                                            <HighLightItemList
                                                conteudo={item}
                                                setLoading={setLoading}
                                                chamadaBanners={chamadaBanners}
                                                index={index}
                                                bsMais={true}
                                                alteraPosicao={alteraPosicao}
                                                excluirDestaque={excluirDestaque}
                                            />
                                        )
                                    })}
                                </TabPane>
                            </TabContent> */}
                        </>
                    }
                </div>
            </div>
        </div>
    )
}


export default withRouter(HighLightsV2List);